import {createAction} from '@reduxjs/toolkit';

export {clearContracts} from '../../contracts/services/actions';
export const clearError = createAction('CLEAR_PRICING_ERROR');
